import { render, staticRenderFns } from "./NewCalendar.vue?vue&type=template&id=0220271c&scoped=true"
import script from "./NewCalendar.vue?vue&type=script&lang=ts"
export * from "./NewCalendar.vue?vue&type=script&lang=ts"
import style0 from "./NewCalendar.vue?vue&type=style&index=0&id=0220271c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0220271c",
  null
  
)

export default component.exports